export const TEST_IDS = {
  createIssueButton: 'create-issue-button',
  createMoreIssuesCheckbox: 'create-more-check',
  templateList: 'template-list',
  issueCreatedLink: 'issue-created-link',
  issueCreatedAnnouncement: 'issue-created-announcement',
  repositoryAndTemplateDialog: 'repository-and-template-picker-dialog',
  templatePickerButton: 'template-picker-button',
}
